// import React, { useEffect, useState } from "react";
// import DateRangePicker from "react-daterange-picker";
// import "react-daterange-picker/dist/css/react-calendar.css";

// import originalMoment from "moment";
// import { extendMoment } from "moment-range";
// import { useDispatch } from "react-redux";
// import { setTimeSeries } from "../../../redux/features/dashboardSlice";

// const moment = extendMoment(originalMoment);
// const today = moment();
// const stateDefinitions = {
//   unavailable: {
//     selectable: false,
//     color: "#78818b",
//     label: "Unavailable",
//   },
// };
// const dateRanges = [
//   {
//     state: "unavailable",
//     range: moment.range(today.clone().subtract(4, "days"), today.clone()),
//   },
// ];
// export default function DateRangePickerr(props) {
//   const today = moment();
//   const dispatch = useDispatch();

//   const [states, setStates] = useState({
//     value: moment.range(today.clone().subtract(4, "days"), today.clone()),
//     dateRanges: [
//       {
//         state: "enquire",
//         range: moment.range(
//           moment().add(2, "weeks").subtract(5, "days"),
//           moment().add(2, "weeks").add(6, "days")
//         ),
//       },
//       {
//         state: "unavailable",
//         range: moment.range(
//           moment().add(3, "weeks"),
//           moment().add(3, "weeks").add(5, "days")
//         ),
//       },
//     ],
//   });

//   const onSelect = (value, states) => {
//     setStates({ value, states });
//   };

//   useEffect(() => {
//     dispatch(
//       setTimeSeries({
//         start: states.value.start.format("DD-MM-YYYY"),
//         end: states.value.end.format("DD-MM-YYYY"),
//       })
//     );
//   }, [states]);

//   return (
//     <>
//       <DateRangePicker
//         months={2}
//         value={states.value}
//         // stateDefinitions={stateDefinitions}
//         // dateStates={dateRanges}
//         onSelect={onSelect}
//         maximumDate={moment().add(1, "months").calendar()}
//         minimumDate={moment().subtract(1, "months").calendar()}
//         singleDateRange={true}
//         numberOfCalendars={2}
//         showLegend={true}
//         rangeColors={["#f33e5b", "#3ecf8e", "#fed14c"]}
//       />
//     </>
//   );
// }

import {
  addDays,
  endOfDay,
  startOfDay,
  startOfYear,
  startOfMonth,
  endOfMonth,
  endOfYear,
  addMonths,
  addYears,
  startOfWeek,
  endOfWeek,
  isSameDay,
  differenceInCalendarDays,
} from "date-fns";
import { useEffect, useState } from "react";
import { DateRangePicker, defaultStaticRanges } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useDispatch } from "react-redux";
import { setTimeSeries } from "../../../redux/features/dashboardSlice";
import moment from "moment";
export default function DateRangePickerr(maxDate) {
  const dispatch = useDispatch();
  const [state, setState] = useState([
    {
      startDate: startOfMonth(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  let screensize = window?.innerWidth;

  useEffect(() => {
    dispatch(
      setTimeSeries({
        start: moment(state[0].startDate).format("DD-MM-YYYY"),
        end: moment(state[0].endDate).format("DD-MM-YYYY"),
      })
    );
  }, [state]);

  return (
    <>
      {screensize > 667 ? (
        <DateRangePicker
          onChange={(item, val) => {
            // console.log({ item });
            if (item.selection.endDate < new Date()) {
              setState([item.selection]);
            }
          }}
          maxDate={new Date()}
          // showSelectionPreview={true}
          // moveRangeOnFirstSelection={false}
          months={2}
          ranges={state}
          direction="horizontal"
          color="#F86B02"
          inputRanges={[]}
          staticRanges={[
            ...defaultStaticRanges,
            // {
            //   label: "This Month",
            //   range: () => ({
            //     startDate: startOfYear(addYears(new Date(), -1)),
            //     endDate: endOfYear(addYears(new Date(), -1)),
            //   }),
            //   isSelected(range) {
            //     const definedRange = this.range();
            //     return (
            //       isSameDay(range.startDate, definedRange.startDate) &&
            //       isSameDay(range.endDate, definedRange.endDate)
            //     );
            //   },
            // },

            {
              label: "This Month",
              range: () => ({
                startDate: startOfMonth(new Date()),
                endDate: endOfMonth(new Date()),
              }),
              isSelected(range) {
                const definedRange = this.range();
                return (
                  isSameDay(range.startDate, definedRange.startDate) &&
                  isSameDay(range.endDate, definedRange.endDate)
                );
              },
            },
          ]}
          // staticRanges={[]}
        />
      ) : (
        <DateRangePicker
          onChange={(item, val) => {
            // console.log({ item });
            if (item.selection.endDate < new Date()) {
              setState([item.selection]);
            }
          }}
          maxDate={new Date()}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={1}
          ranges={state}
          direction="vertical"
          scroll={{ enabled: true }}
          color="#F86B02"
          staticRanges={[]}
          inputRanges={[]}
        />
      )}
    </>
  );
}
